export class Overlay {
    constructor(element, gallery) {
        this.element = element;
        this.gallery = gallery;

        this.element.addEventListener('click', _ => this.close());

        this.closeBtn = document.createElement('div');
        this.closeBtn.classList.add('gallery__close-btn');
        this.closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">' +
            '  <polygon fill-rule="evenodd" points="19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12" transform="translate(-5 -5)"/>' +
            '</svg>';
        this.closeBtn.addEventListener('click', () => this.close());

        gallery.wrapper.appendChild(this.closeBtn);
    }

    open(index) {
        this.element.classList.add('gallery__overlay--open')
        this.gallery.init();
        if(index !== undefined) {
            this.gallery.changeSlide(index);
        }
    }

    close() {
        this.element.classList.remove('gallery__overlay--open')
    }
}
